import { createFileRoute } from "@tanstack/react-router";
import { PortalHomeContent } from "@/components/portal/PortalHomeContent";

export const Route = createFileRoute("/portal/connectors/")({
  component: ConnectorsPage,
});

function ConnectorsPage() {
  return <PortalHomeContent />;
}
